import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from './AppIcon';
import Button from './ui/Button';
import NotificationCenter from './NotificationCenter';

const Header = () => {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navigationItems = [
    { label: 'Dashboard', path: '/personal-dashboard', icon: 'LayoutDashboard' },
    { label: 'Find Support', path: '/helper-discovery', icon: 'Search' },
    { label: 'My Profile', path: '/helper-profile-management', icon: 'User' },
    { label: 'Admin', path: '/admin-console', icon: 'Settings' },
    { label: 'Performance', path: '/system-performance-dashboard', icon: 'Activity' },
  ];

  const isActive = (path) => location?.pathname === path;

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <>
      <header className="header">
        <div className="header-container">
          <Link to="/personal-dashboard" className="header-logo">
            <img 
              src="/assets/images/CWTCH-1764836850908.png" 
              alt="Cwtch logo - teal brush stroke with 'pursuing happiness' tagline" 
              className="h-10 w-auto"
            />
          </Link>

          <nav className="header-nav">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`header-nav-item ${isActive(item?.path) ? 'active' : ''}`}
              >
                {item?.label}
              </Link>
            ))}
          </nav>

          <div className="header-actions">
            <NotificationCenter />
            <Button
              variant="ghost"
              size="icon"
              iconName="Menu"
              onClick={toggleMobileMenu}
              className="header-mobile-toggle"
            />
          </div>
        </div>
      </header>
      {mobileMenuOpen && (
        <>
          <div className="mobile-menu-overlay" onClick={closeMobileMenu} />
          <div className="mobile-menu">
            <div className="mobile-menu-header">
              <span className="text-lg font-semibold">Menu</span>
              <Button
                variant="ghost"
                size="icon"
                iconName="X"
                onClick={closeMobileMenu}
              />
            </div>
            <nav className="mobile-menu-nav">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  className={`mobile-menu-item ${isActive(item?.path) ? 'active' : ''}`}
                  onClick={closeMobileMenu}
                >
                  <Icon name={item?.icon} size={20} />
                  <span>{item?.label}</span>
                </Link>
              ))}
            </nav>
          </div>
        </>
      )}
    </>
  );
};

export default Header;